export default __webpack_public_path__ + "c240752f419e0d88395df39f2735c618.png";